// ─── Las pestañas de la ficha de una persona ────────────────────────────────
// Los paneles se eligen por CLAVE, no por índice: una pestaña que se esconde
// (por un módulo apagado) no corre a las demás.
//
// Las de un módulo se esconden si el seminario no lo usa: Admisiones
// (admisiones), Pagos y Becas (finanzas), Bitácora CRM (captación).
//
// Con el flag, dos pestañas cambian de contenido en su lugar:
//   · 3 «Calificaciones» (notas numéricas) → «Expediente» (letra, puntos y
//     créditos, y lo que está en curso aparte);
//   · 4 «Progreso por programa» → «Avance de la credencial».
// Sin el flag —todos los demás seminarios— la lista es la de siempre.

export type PersonDetailTabKey =
  | 'general'
  | 'admissions'
  | 'enrollments'
  | 'grades'
  | 'progressByProgram'
  | 'academicRecord'
  | 'credentialProgress'
  | 'programEnrollment'
  | 'payments'
  | 'scholarships'
  | 'crm';

export interface PersonDetailTab {
  key: PersonDetailTabKey;
  /** Clave i18n (namespace `sis`) de la etiqueta. */
  label: string;
}

export function personDetailTabs(opts: {
  credentialRecord: boolean;
  isActiveStudent: boolean;
  /** ¿El seminario usa este módulo? Sin la función, todos encendidos. */
  moduleEnabled?: (key: 'admissions' | 'finance' | 'recruitment') => boolean;
}): PersonDetailTab[] {
  const on = opts.moduleEnabled ?? (() => true);
  const tabs: PersonDetailTab[] = [{ key: 'general', label: 'people.profile.tabs.general' }];
  if (on('admissions')) tabs.push({ key: 'admissions', label: 'people.profile.tabs.admissions' });
  tabs.push(
    { key: 'enrollments', label: 'people.profile.tabs.enrollments' },
    opts.credentialRecord
      ? { key: 'academicRecord', label: 'academicRecord.tabs.record' }
      : { key: 'grades', label: 'people.profile.tabs.grades' },
    opts.credentialRecord
      ? { key: 'credentialProgress', label: 'academicRecord.tabs.credential' }
      : { key: 'progressByProgram', label: 'people.profile.tabs.progressByProgram' },
    // H5: la matrícula a programa es del núcleo —con o sin el flag, con o sin
    // Admisiones—. Va después del avance, así las pestañas 3 y 4 no se mueven.
    { key: 'programEnrollment', label: 'people.profile.tabs.programEnrollment' },
  );
  if (opts.isActiveStudent && on('finance')) {
    tabs.push(
      { key: 'payments', label: 'people.profile.tabs.payments' },
      { key: 'scholarships', label: 'people.profile.tabs.scholarships' },
    );
  }
  if (on('recruitment')) tabs.push({ key: 'crm', label: 'people.profile.tabs.crm' });
  return tabs;
}
